import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorConditionGTM } from "../../../Utils/googleTags";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";

type contentDetailsInitialStateType = {
  loginPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: contentDetailsInitialStateType = {
  loginPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = "login-content.json";

export const getLoginPageContent = createAsyncThunk(
  "get/login-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`}
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const contentDetailSlice = createSlice({
  name: "login-content/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLoginPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLoginPageContent.fulfilled, (state, action) => {
      state.loginPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getLoginPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "login AEM Content",
        action.error?.message,
        action?.type
      );
      state.loginPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default contentDetailSlice.reducer;
